module.exports = __webpack_public_path__ + "static/img/icon_scan.55cf3ec4.png";